import { all, takeLatest, put } from 'redux-saga/effects';
import { GET_ROLES } from './constants';
import { requestRoles } from './api';
import { getRolesSuccess } from './actions';

/**
 *
 * @returns {IterableIterator<PutEffect<{roles: *, type: string}>>}
 */
function* getRoles() {
    const roles = yield requestRoles();
    if (roles) {
        yield put(getRolesSuccess(roles));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchRoles() {
    yield takeLatest(GET_ROLES, getRoles);
}

function* rolesSaga() {
    yield all([
        watchRoles()
    ]);
}

export default rolesSaga;